import { httpsCallable } from "firebase/functions";
import { functions } from "../../resource/functions";

export const createUserWithAdmin = httpsCallable<
  {
    email: string;
    password: string;
    name: string;
    type?: "admin" | "test" | "user";
  },
  { uid: string }
>(functions, "createUser");
